<template>
  <!-- Modal -->
  <div
    class="modal fade text-xs-left"
    id="modalCAM"
    tabindex="-1"
    v-if="$store.state.active_cam"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="closeBtnCam"
            ref="closeCAM"
            class="close"
            data-dismiss="modal"
            @click="
              $store.state.active_cam = false;
              toggleCamera();
            "
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" style="margin-top: 0">
            <i class="nc-icon nc-camera-compact"></i> Camera
            <i v-if="errors.length > 0"> - Not Allowed</i>
          </h4>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="card-block text-xs-center" v-if="cam_loading">
              <div class="mt-2">
                <i class="icon-gear-a spinner font-large-2"></i>
              </div>
            </div>
            <div class="alert alert-warning mb-2" v-if="errors.length > 0">
              <p
                style="margin: 0"
                v-for="(error, index) in errors"
                :key="index"
              >
                {{ error }}
              </p>
            </div>
            <div v-if="isCameraOpen" style="width: 100%">
              <video
                v-show="!isPhotoTaken"
                ref="camera"
                autoplay
                style="width: 100%"
              ></video>
              <canvas
                v-show="isPhotoTaken"
                id="photoTaken"
                ref="canvas"
                style="max-width: 100%; max-height: 100%"
              ></canvas>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div style="display: flex; justify-content: center">
            <button type="button" class="btn btn-warning" @click="changeCam()">
              <h3 style="margin: 0"><i class="nc-icon nc-refresh-69"></i></h3>
            </button>
            <button type="button" class="btn btn-warning" @click="takePhoto">
              <h3 style="margin: 0">
                <i class="nc-icon nc-camera-compact"></i>
              </h3>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-show="cam_loading">
      <div
        class="loader-overlay"
        id="point-loader"
        style="position: fixed !important"
      >
        <div
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <atom-spinner
            :animation-duration="1000"
            :size="160"
            :color="'#ff1d5e'"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
</template>

<script>
import { AtomSpinner } from "epic-spinners";

export default {
  name: "CameraCapth",
  data() {
    return {
      resultCam: null,
      cam_loading: true,
      isCameraOpen: false,
      isPhotoTaken: false,
      destroyed_cam: false,
      errors: [],
      front: true,
    };
  },
  components: { AtomSpinner },
  props: {
    res_out: { type: Function, required: false },
    //activeQR: {type: Boolean, required: false, default: false },
  },
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isPhotoTaken = false;
        this.stopCameraStream();
        this.isCameraOpen = false;
        this.cam_loading = true;
      } else {
        //this.isCameraOpen = true;
        this.createCameraElement(this.front);
      }
    },
    changeCam() {
      this.errors = [];
      this.stopCameraStream();
      this.front = !this.front;
      this.createCameraElement(this.front);
    },
    createCameraElement(front) {
      this.errors = [];
      this.isCameraOpen = true;

      let sideCamera = null;
      if (front) {
        sideCamera = { facingMode: "user" };
      } else {
        sideCamera = { facingMode: { exact: "environment" } };
      }

      const constraints = (window.constraints = {
        audio: false,
        video: sideCamera,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.cam_loading = false;

          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          if (
            error.name === "NotAllowedError" ||
            error.name === "PermissionDeniedError"
          ) {
            console.log("Permission for Camera not granted");
            this.errors.push("Permission for Camera not granted");
          } else {
            this.errors.push("Other problem with access to camera.");
          }
          console.log("getUserMedia error: " + error.name, error);
          this.cam_loading = false;
        });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },
    takePhoto() {
      this.isPhotoTaken = !this.isPhotoTaken;
      const canvas = this.$refs.canvas;
      const camera = this.$refs.camera;
      const ctx = canvas.getContext("2d");

      canvas.width = camera.clientWidth;
      canvas.height = camera.clientHeight;

      ctx.drawImage(camera, 0, 0, canvas.width, canvas.height);

      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const dateText = `${pad(now.getDate())}.${pad(
        now.getMonth() + 1
      )}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;

      const w = canvas.width;
      const h = canvas.height;
      const margin = Math.round(w * 0.02);
      const fontSize = Math.round(w * 0.03);

      ctx.font = `${fontSize}px Arial`;
      ctx.textBaseline = "bottom";
      ctx.textAlign = "right";
      ctx.lineWidth = Math.max(2, fontSize * 0.15);
      ctx.strokeStyle = "rgba(0,0,0,0.6)";
      ctx.fillStyle = "white";

      ctx.strokeText(dateText, w - margin, h - margin);
      ctx.fillText(dateText, w - margin, h - margin);

      this.resultCam = canvas.toDataURL("image/png");

      if (this.isValid(this.resultCam)) {
        this.res_out(this.resultCam);
      }

      this.$refs.closeCAM.click();
    },
  },
  watch: {
    "$store.state.active_cam": function () {
      if (this.$store.state.active_cam) {
        this.toggleCamera();
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Camera.vue